var classes = {
  "calendarHeader": "m_730a79ed",
  "calendarHeaderLevel": "m_f6645d97",
  "calendarHeaderControl": "m_2351eeb0",
  "calendarHeaderControlIcon": "m_367dc749"
};
export { classes as default };